import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'
import classnames from 'classnames'
import InputMask from 'react-input-mask'

import styles from './styles.css'

class DurationInput extends PureComponent {
  static propTypes = {
    value: PropTypes.number,
  }

  static defaultProps = {
    value: 0,
  }

  state = {
    timeInput: '',
  }

  componentDidMount() {
    const { value } = this.props
    this.setInitialValue(value)
  }

  componentWillReceiveProps(nextProps) {
    const { value } = nextProps
    this.setInitialValue(value)
  }

  setInitialValue = duration => {
    if (duration) {
      const timeInput = this.durationToString(duration)
      this.setState({
        timeInput,
      })
    }
  }

  handleInputChange = (event, callback) => {
    const { value } = event.currentTarget
    const { onChange } = this.props

    const durationString = this.stringToDuration(value)

    onChange(durationString)
    this.setState({
      timeInput: value,
    })
  }

  stringToDuration = timeString => {
    const minutes = timeString.substring(0, 2) * 1
    const seconds = timeString.substring(3) * 1
    const duration = minutes + seconds / 60
    return duration
  }

  durationToString = duration => {
    const totalSeconds = duration * 60

    const minutes = Math.floor(totalSeconds / 60)
    const seconds = totalSeconds % 60
    const minuteStr = minutes.toString().padStart(2, '0')
    const secondStr = seconds.toString().padStart(2, '0')

    return `${minuteStr}:${secondStr}`
  }

  _onBlur = () => {
    const { timeInput } = this.state
    if (this.stringToDuration(timeInput) === 0)
      this.setState({
        timeInput: '',
      })
  }

  render() {
    const { timeInput } = this.state
    const { ...props } = this.props
    return (
      <InputMask
        {...props}
        value={timeInput}
        onBlur={this._onBlur}
        onChange={this.handleInputChange}
        mask="99:99"
        maskChar="0"
        alwaysShowMask={false}
      />
    )
  }
}

export default DurationInput



// WEBPACK FOOTER //
// ./src/components/durationInput/index.js